<template>
  <div class="ace">
    <Intro v-if="!calculator" @setCalculator="setCalculator" />
    <GrainBeans v-if="calculator == 'grain'" />
    <Feed v-if="calculator == 'feed'" />
    <button v-if="!!calculator" @click="clearCalculator" class="ace__reset">
      Try another calculation
    </button>
    <Divider />
    <Footnote />
    <Logos />
  </div>
</template>

<script>
import Intro from './components/Intro.vue';
import GrainBeans from './components/GrainBeans/GrainBeans.vue';
import Feed from './components/Feed/Feed.vue';
import Divider from './components/Layout/Divider.vue';
import Footnote from './components/Shared/Footnote.vue';
import Logos from './components/Logos.vue';

export default {
  data() {
    return {
      calculator: '',
    };
  },
  methods: {
    setCalculator(type) {
      window.scrollTo(0, 0);

      this.calculator = type;
    },
    clearCalculator() {
      this.setCalculator(null);
    },
  },
  components: {
    Intro,
    GrainBeans,
    Feed,
    Divider,
    Footnote,
    Logos,
  },
};
</script>

<style lang="scss">
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #707070;

  // font-family: 'Roboto Condensed', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}
p {
  margin-top: 1rem;
}

input,
select,
button {
  color: #707070;
}

.ace {
  text-align: center;

  background-image: image-set(
    url('./assets/images/bg.png') 1x,
    url('./assets/images/bg@2x.png') 2x
  );
  background-position: calc(100% + 215px) calc(100% + 280px);
  background-repeat: no-repeat;
  color: #707070;

  margin-bottom: -50px;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 65px;

  &-content {
    margin-top: 55px;
    width: 100%;
  }
  &__reset {
    cursor: pointer;
    text-decoration: underline;
    text-transform: uppercase;

    background: none;
    border: none;

    margin-top: 40px;

    font-weight: 700;

    appearance: none;
  }
}

.ace-form {
  text-align: left;
  &__title {
    color: #02a94e;
  }
  &__intro {
    margin-bottom: 30px;
    margin-top: 15px;
    p {
      margin-top: 0;
    }
  }
  &__row {
    margin-left: -10px;
    margin-right: -10px;

    display: flex;

    flex: 1;
    & + & {
      margin-top: 15px;
    }
  }
  &__field {
    padding-left: 10px;
    padding-right: 10px;

    display: flex;
    flex-direction: column;

    flex: 1;
  }
  &__actions {
    padding-left: 10px;
    padding-right: 10px;

    display: flex;

    flex: 1;
    justify-content: space-between;
  }
  &__label {
    color: #02a94e;

    margin-bottom: 5px;

    font-weight: 500;
  }
  &__input {
    background-color: #f1f1f2;
    border: 0;
    box-shadow: none;
    color: #707070;

    min-height: 30px;
    padding: 0 10px;
    width: 100%;

    line-height: 30px;
    input {
      background: none;
      border: none;
      outline: none !important;

      width: 100%;
    }
    &.is-invalid {
      border: 1px solid #cc0000;
    }
    &--select,
    &--checkbox {
      padding: 0;
    }
    &--select {
      background-image: url("data:image/svg+xml,%3Csvg data-name='9' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11.864 7.699'%3E%3Cpath data-name='Path 36' d='M5.932 7.7L0 1.767 1.767 0l4.165 4.165L10.1 0l1.767 1.767z' fill='%2302A94E'/%3E%3C/svg%3E");
      background-position: calc(100% - 10px) 50%;
      background-repeat: no-repeat;
      background-size: 12px 8px;

      overflow: hidden;
      select {
        background: none;
        border: 0;
        color: #707070;
        outline: none !important;

        padding: 0 10px;
        width: 120%;

        line-height: 30px;

        -webkit-appearance: none;
      }
    }
    &--checkbox {
      background: none;

      margin-top: 5px;
      label {
        margin: 0;
        &:before {
          content: '';
          text-align: center;
          transition: 300ms ease opacity;

          background-color: #ffffff;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: 20px;
          border: 1px solid #d8d8d8;
          color: #056cb6;

          height: 30px;
          margin-right: 15px;
          width: 30px;

          display: flex;

          justify-content: center;
          align-items: center;
          flex: 0 0 auto;
        }
      }
      input[type='checkbox'] {
        opacity: 0;

        position: absolute;
        & + label {
          cursor: pointer;

          color: #909191;

          margin-bottom: 0;

          display: flex;

          line-height: 1;

          justify-content: flex-start;
          align-items: center;
        }
        &:checked + label::before {
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%2302A94E' d='M461.6 109.6l-54.9-43.3c-1.7-1.4-3.8-2.4-6.2-2.4-2.4 0-4.6 1-6.3 2.5L194.5 323s-78.5-75.5-80.7-77.7c-2.2-2.2-5.1-5.9-9.5-5.9s-6.4 3.1-8.7 5.4c-1.7 1.8-29.7 31.2-43.5 45.8-.8.9-1.3 1.4-2 2.1-1.2 1.7-2 3.6-2 5.7 0 2.2.8 4 2 5.7l2.8 2.6s139.3 133.8 141.6 136.1c2.3 2.3 5.1 5.2 9.2 5.2 4 0 7.3-4.3 9.2-6.2l249.1-320c1.2-1.7 2-3.6 2-5.8 0-2.5-1-4.6-2.4-6.4z'/%3E%3C/svg%3E");
        }
      }
    }
  }
}
</style>
